// src/pages/PrivateLogin.jsx
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const LOCALSTORAGE_KEY = "isAdmin";
const PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || "changeme"; // fallback

export default function PrivateLogin() {
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const next = searchParams.get("next") || "/";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pwd === PASSWORD) {
      localStorage.setItem(LOCALSTORAGE_KEY, "true");
      navigate(next, { replace: true });
    } else {
      setError("Incorrect password");
    }
  };

  return (
    <div className="max-w-sm mx-auto mt-24 p-6 bg-white rounded shadow">
      <h1 className="text-xl font-semibold mb-4">Admin Login</h1>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="text-sm block mb-1">Password</label>
          <input
            type="password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            className="w-full border rounded px-3 py-2"
            autoFocus
          />
        </div>


        {error && <div className="text-sm text-red-600">{error}</div>}

        <button
          type="submit"
          className="w-full bg-blue-600 text-white rounded py-2 hover:bg-blue-700 transition"
        >
          Login
        </button>
      </form>
    </div>
  );
}
